import { alpha, createTheme, responsiveFontSizes } from "@mui/material";
import type { Components, PaletteOptions, Theme } from "@mui/material/styles";

import commonTheme from "./commonTheme";

const primaryMainBase = "#00B5FE";
const selectedOpacity = 0.1;

export const palette: PaletteOptions = {
  mode: "light",
  primary: {
    main: primaryMainBase,
    dark: "#028AD6",
    light: "#50CDFF",
    contrastText: "#FFFFFF",
    selected: alpha(primaryMainBase, selectedOpacity),
  },
  secondary: {
    main: "#252525",
    dark: "#949191",
    light: "#BEBDBD",
    contrastText: "rgba(255, 255, 255, 0.87)",
  },
  action: {
    active: "rgba(0, 0, 0, 0.56)",
    hoverOpacity: 0.04,
    selectedOpacity: selectedOpacity,
    focusOpacity: 0.12,
    focusVisibleOpacity: 0.3,
    disabledBackground: "#E0E0E0",
  },
  background: {
    default: "#F3F7FA",
    paper: "#FFFFFF",
  },
};

export const components: Components<Omit<Theme, "components">> = {
  ...commonTheme.components,
  MuiAppBar: {
    styleOverrides: {
      root: {
        background: "white",
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      icon: {
        color: palette.action?.active,
      },
    },
  },
};

const lightTheme = responsiveFontSizes(
  createTheme({
    ...commonTheme,
    palette,
    components,
  })
);

export default lightTheme;
